import React from 'react'

const Role = () => {
  return (
    <div>Role</div>
  )
}

export default Role